<template>
  <div
    class="halobree flex h-full w-full cursor-default"
    data-cy="unusable-step-content"
  >
    <div class="flex h-full items-center bg-red-500">
      <div class="mx-1">
        <icon-base
          :icon="IconWarningTriangle"
          height="12"
          width="13"
          class="text-white"
        />
      </div>
    </div>
    <div
      class="flex h-full w-full flex-col justify-between rounded-r border-t border-r border-b border-dashed border-red-500 p-4"
    >
      <div class="flex flex-col">
        <span class="font-semibold text-gray-600">
          {{ step.title }}
        </span>
        <span class="text-gray-500/90">
          {{ $t("ORCHESTRATION.UNUSABLE_STEP.TITLE") }}
        </span>
        <span class="text-gray-500/90">
          {{ $t("ORCHESTRATION.UNUSABLE_STEP.DESCRIPTION") }}
        </span>
      </div>
      <div class="flex items-center justify-end">
        <button
          class="mr-3 cursor-pointer font-semibold text-gray-500"
          @click.stop="deleteStep"
        >
          {{ $t("COMMON.DELETE") }}
        </button>
        <button
          class="cursor-pointer font-semibold text-blue-600"
          @click.stop="replaceStep"
        >
          {{ $t("COMMON.REPLACE") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";

import IconWarningTriangle from "@/components/icons/IconWarningTriangle.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { IStep } from "@/models/orchestration";

const { step } = defineProps<{ step: IStep }>();
const { commit } = useStore();

const deleteStep = () => {
  commit("orchestration/deleteStep", { stepId: step.id });
};

const replaceStep = () => {
  commit("orchestration/setReplaceStepId", step.id);
};
</script>
